<div class="page-container d-flex">
    <div class="lamp__wrap">
        <div class="lamp">
            <div class="cable"></div>
            <div class="cover"></div>
            <div class="in-cover">
                <div class="bulb"></div>
            </div>
            <div class="light"></div>
        </div>
    </div>

    <div class="d-flex flex-column p-5 mt-auto">
        <div class="d-flex flex-column align-items-center">
            <h1 class="text-center">Oops! Page Not Found</h1>
            <img src="assets/svg/not-found.svg" alt="404">
            <p class="text-center">The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.</p>
        </div>
        <div class="d-flex justify-content-center w-100">
            <button class="gohome-button w-100" [routerLink]="['/dashboard/summary']">Go To Dashboard</button>
        </div>
    </div>
</div>